exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover .el-popconfirm .el-popconfirm__action .el-button {\n  border: 0.005208rem solid #ccced2;\n  border-radius: 0.026042rem;\n  font-size: 0.0625rem;\n  height: 0.15625rem;\n  padding: 0.026042rem 0.052083rem;\n}\n.el-popover .el-popconfirm .el-popconfirm__action .el-button:nth-child(1) {\n  background-color: #fff;\n  color: #333333;\n}\n.el-popover .el-popconfirm .el-popconfirm__action .el-button:nth-child(2) {\n  background: #00338d;\n  color: #fff;\n}", ""]);

// exports
